<template>
  <div class="overlay-force-landscape">
    <img src="@/assets/practices/global/overlay_landscape.svg" alt="landscape_mode" />
    <p>This app only runs in landscape mode. Please turn your device.</p>
  </div>
</template>

<script>
export default {
  name: 'OverlayForcedLandscape',
};
</script>

<style lang="scss" scoped>
.overlay-force-landscape {
  align-items: center;
  background-color: black;
  color: white;
  display: none;
  flex-direction: column;
  height: 100vh;
  justify-content: center;
  position: absolute;
  top: 0;
  width: 100vw;
  z-index: 1000;

  img {
    margin-bottom: 2em;
    width: 25%;
  }

  p {
    text-align: center;
    width: 90%;
  }
}

@media (orientation: portrait) {
  .overlay-force-landscape {
    display: flex;
  }
}
</style>
